angular.module('picmonicng').directive('trialStatusBlock', [
  'UserService',
  'SplitTestService',
  function (UserService, SplitTestService) {
    return {
      restrict: 'E',
      transclude: true,
      replace: true,
      templateUrl: function (tElement, tAttrs) {
        return '/templates/directives/trial-status-block-v3.html';
        // return tAttrs.home
        //   ? '/templates/directives/trial-status-block-v2.html'
        //   : '/templates/directives/trial-status-block.html';
      },
      scope: {
        fullWidth: '=',
        markets: '=',
        home: '=',
        quiz: '=',
        notPlayable: '<',
      },
      controller: [
        '$scope',
        '$interval',
        '$filter',
        'TokenService',
        'UserService',
        'MarketOptionsConfig',
        'Picmonics',
        function ($scope, $interval, $filter, TokenService, UserService, MarketOptionsConfig, Picmonics) {
          $ctrl = this;
          $scope.UserService = UserService;
          $scope.TokenService = TokenService;
          $scope.MarketOptionsConfig = MarketOptionsConfig;

          $scope.isUserEducator = UserService.user.role === 'Professor';
          $scope.isEducatorFreeTrial =
            UserService.user.active_premium_types.length === 0 &&
            UserService.user.free_trial_expiration > Date.now() / 1000;

          //Start TokenService countdown when trial status is initialized
          !UserService.user.approved_educator && TokenService.startCountDown();

          // Check to see if you have access to the card
          $scope.inActiveMarket = false;
          $scope.inPseudoMarket = false;
          $scope.inMarket = false;

          if ($scope.markets && UserService.user.user_id) {
            $scope.inMarket = !!$filter('filter')($scope.markets, { market_id: UserService.user.lead }, true).length;

            angular.forEach($scope.markets, function (market) {
              if (!!$filter('filter')(UserService.user.active_markets, { market_id: market.market_id }, true).length) {
                $scope.inActiveMarket = true;
              }

              if (
                MarketOptionsConfig.getMarketById(market.market_id).is_pseudo ||
                !!$filter('filter')(UserService.user.market.addons, { market_id: market.market_id }, true).length
              ) {
                $scope.inMarket = true;
                $scope.inPseudoMarket = true;
                $scope.pseudoMarket = MarketOptionsConfig.getMarketById(market.market_id);
              }
            });
          }
          $scope.visible = UserService.user.is_trial || !$scope.inActiveMarket || $scope.notPlayable;

          if (!$scope.inActiveMarket && !$scope.inPseudoMarket && !$scope.inMarket && $scope.markets) {
            $scope.market = MarketOptionsConfig.getMarketById($scope.markets[0].market_id);
          } else {
            $scope.market = MarketOptionsConfig.getMarketById(
              $scope.inPseudoMarket ? $scope.pseudoMarket.id : UserService.user.lead
            );
          }

          if ($scope.home) {
            $scope.trending = Picmonics.query({
              type: 'trending',
              limit: 1,
            });
          }

          //TokenService countdown must be manual stopped with scope is destroy
          //or counter will just continue to run on the app :-(
          $scope.$on('$destroy', function () {
            TokenService.stopCountDown();
          });

          $scope.getTrialText = function () {
            if (UserService.user.role === 'Professor') {
              if ($ctrl.isEducatorFreeTrial)
                return 'Your free trial includes a limited number of Picmonics until we verify your educator status and unlock unlimited access for 7 days.';
              return 'Your free educator trial has expired. You now have access to a limited number of Picmonics. Connect with us to learn more about a program partnership.';
            }
            return 'Unlock Unlimited access to the entire Picmonic for ' + $scope.market.name + 'Library and Quizzing';
          };
        },
      ],
    };
  },
]);
